import { render, staticRenderFns } from "./invadobay-compact-preview.vue?vue&type=template&id=2ee6283c&scoped=true"
import script from "./invadobay-compact-preview.vue?vue&type=script&lang=js"
export * from "./invadobay-compact-preview.vue?vue&type=script&lang=js"
import style0 from "./invadobay-compact-preview.vue?vue&type=style&index=0&id=2ee6283c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee6283c",
  null
  
)

export default component.exports